import { Action } from '@ngrx/store';
import { UPQuestionAssessmentResponse } from 'up';

export enum QuestionActions {
  LoadQuestionAssessment = '[Questions] Load Questions',
  RemoveQuestionAssessmentType = '[Questions] Remove Question',
  RemoveAllQuestionAssessments = '[Questions] Remove All Question',
}

export class LoadQuestionAssessment implements Action {
  public readonly type = QuestionActions.LoadQuestionAssessment;
  constructor(public payload: UPQuestionAssessmentResponse) {}
}

export class RemoveQuestionAssessmentType implements Action {
  public readonly type = QuestionActions.RemoveQuestionAssessmentType;
  constructor(public payload: string) {}
}

export class RemoveAllQuestionAssessments implements Action {
  public readonly type = QuestionActions.RemoveAllQuestionAssessments;
}

export type QuestionActionsUnion =
  | LoadQuestionAssessment
  | RemoveQuestionAssessmentType
  | RemoveAllQuestionAssessments;
